export enum FilterSplitStrategy {
  FILTER_SPLIT_STRATEGY_UNKNOWN = 'FILTER_SPLIT_STRATEGY_UNKNOWN',
  /**
   * ES should only return products, not aggregations
   */
  PRODUCTS_ONLY = 'PRODUCTS_ONLY',
  /**
   * ES should only return aggregations, no products
   */
  AGGREGATIONS_ONLY = 'AGGREGATIONS_ONLY',
  /**
   * ES should return both aggregations and products
   */
  PRODUCTS_AND_AGGREGATIONS = 'PRODUCTS_AND_AGGREGATIONS',
}
